var _title, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSquare = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "100px",
  height: "100px",
  viewBox: "0 0 100 100",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "providers/google/icon")), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "providers/google/icon",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#F7F7F9",
  x: 0,
  y: 0,
  width: 100,
  height: 100
}), /*#__PURE__*/React.createElement("g", {
  id: "color/google",
  transform: "translate(21.000000, 21.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M29,11.4791667 C33.2775,11.4791667 37.1079167,12.9533333 40.12875,15.8291667 L48.4058333,7.55208333 C43.3791667,2.87583333 36.8179167,0 29,0 C17.6658333,0 7.86625,6.50083333 3.09333333,15.9741667 L12.7358333,23.45375 C15.0195833,16.5783333 21.4358333,11.4791667 29,11.4791667 Z",
  id: "Path",
  fill: "#EA4335"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.7675,29.6645833 C56.7675,27.7675 56.58625,25.9308333 56.3083333,24.1666667 L29,24.1666667 L29,35.0658333 L44.6358333,35.0658333 C43.935,38.6425 41.905,41.6875 38.86,43.7416667 L48.2004167,50.9916667 C53.65,45.9408333 56.7675,38.4733333 56.7675,29.6645833 L56.7675,29.6645833 Z",
  id: "Path",
  fill: "#4285F4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.72375,34.54625 C12.14375,32.7941667 11.8054167,30.9333333 11.8054167,29 C11.8054167,27.0666667 12.1316667,25.2058333 12.72375,23.45375 L3.08125,15.9741667 C1.11166667,19.8891667 0,24.3116667 0,29 C0,33.6883333 1.11166667,38.1108333 3.09333333,42.0258333 L12.72375,34.54625 Z",
  id: "Path",
  fill: "#FBBC05"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29,58 C36.83,58 43.4154167,55.42625 48.2004167,50.9795833 L38.86,43.7295833 C36.2620833,45.4816667 32.915,46.50875 29,46.50875 C21.4358333,46.50875 15.0195833,41.4095833 12.72375,34.5341667 L3.08125,42.01375 C7.86625,51.4991667 17.6658333,58 29,58 Z",
  id: "Path",
  fill: "#34A853"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSquare);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/square.96131a57447b832cfde596a00d4d4a4b.svg";